export default __webpack_public_path__ + "img/196789e4bc88253b490285a4f415d4a6.svg";